import React, { useState, useRef } from 'react';
// import { serviceOnline } from 'stock/components.new';
import { urlMap } from '@/constant/enums';
import { createPortal } from 'react-dom';
import './index.less';

const Toolbar = () => {
  const [visible, setVisible] = useState(false);
  const [showCallServer, setShowCallServer] = useState(false);
  const [dialogCreated, setDialogCreated] = useState(false);

  const handleServiceOnline = () => {
    if (showCallServer) {
      return;
    }
    setDialogCreated(true);
    setShowCallServer(true);
  };


  return (
    <div className="toolbar-wrapper">
      <div
        id="icon-service-client"
        className="call-service"
        onMouseEnter={() => setVisible(true)}
        onMouseLeave={() => setVisible(false)}
      >
        <div className={`search-service__shim ${visible ? 'search-service__shim--visible' : ''}`} />
        <div
          className={[
            'search-service__popup',
            visible ? 'search-service__popup--visible' : '',
          ].join(' ')}
        >
          <div className="section-buy">
            <div className="section-title"><i className="icon icon-buy" />购买咨询</div>
            <div className="section-buy-body">
              <div className="section-buy-item">
                <div className="section-buy-item-title">客服热线</div>
                <a className="tel" href="tel:4000666417">4000-666-417</a>
                <div className="datetime">周一至周五<br />09:00-18:00</div>
              </div>
              <div className="section-buy-item">
                <div className="section-buy-item-title">扫码咨询</div>
                <img className="qrcode" src="https://static-prod.ituchong.com/operation-resource/stock_footer_weixin_qrcode.jpeg" alt="qrcode" />
              </div>
            </div>
          </div>

          <div className="divider" />

          <div className="section-contribute">
            <div className="section-title"><i className="icon icon-contribute" />供稿咨询</div>
            <div className="section-contribute-body">
              <div>
                <span className="label">客服反馈：</span>
                <a href="mailto:tuku@mail.tuchong.com">tuku@mail.tuchong.com</a>
              </div>
              <div>
                <span className="label">供稿通道：</span>
                <a href={urlMap.get('contributor')} target="_blank" rel="noopener noreferrer">
                  {urlMap.get('contributor')}
                </a>
              </div>
            </div>
          </div>

          <div className="divider" />

          <div className="section-contribute">
            <div className="section-title"><i className="icon icon-resource" />资源合作</div>
            <div className="section-contribute-body">
              <div>
                <span className="label">合作联络：</span>
                <a href="mailto:business@mail.tuchong.com">business@mail.tuchong.com</a>
              </div>
            </div>
          </div>

          <div className="divider" />

          <div className="section-online">
            <div className="section-title"><i className="icon icon-online" />在线咨询</div>
            <button
              type="button"
              className="call-service-button"
              onClick={handleServiceOnline}
            >
              咨询
            </button>
          </div>
        </div>
      </div>
      {dialogCreated && createPortal(
        <div
          className={`customer-service-dialog ${showCallServer ? 'customer-service-dialog-visible' : ''}`}
        >
          <div className="customer-service-dialog__close" onClick={() => setShowCallServer(false)}>
            <i className="c-icon-arrow-down customer-service-dialog__icon"></i>
          </div>
          <iframe
            className="customer-service-dialog__iframe"
            src="https://static-prod.ituchong.com/bdtc-creative-html/chat.html"
          ></iframe>
        </div>,
        document.body,
      )}
    </div>
  );
};

export default Toolbar
